import { createContext } from 'react'

const context = createContext('usersFilter')

export default context